<script>
export default {
  download: async function (file, data) {
    var iconv = require('iconv-lite')
    // CSVの内容
    var csvLine = iconv.encode(data, 'UTF-8')
    var bom = new Uint8Array([0xEF, 0xBB, 0xBF])
    // 指定されたデータを保持するBlobを作成する
    var blob = new Blob([bom, csvLine], {type: 'text/csv;charset=utf-8'})
    // ダウンロード実行...

    if (window.navigator.msSaveBlob) {
      // IE対応
      window.navigator.msSaveBlob(blob, file)
      // msSaveOrOpenBlobの場合はファイルを保存せずに開ける
      window.navigator.msSaveOrOpenBlob(blob, file)
    } else {
      var result = document.createElement('a')
      result.href = window.URL.createObjectURL(blob)
      result.download = file
      document.body.appendChild(result)
      result.click()
    }
  }
}
</script>



// WEBPACK FOOTER //
// Csv.vue?9d4ce49a